






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import FilterCommon from '@/components/filters/FilterCommon.vue';
import Divider from '@/components/common/Divider.vue';
import FilterBase, { FilterItem } from '@/components/filters/FilterBase.vue';
import { Form, SubjectType } from '@/resource/subject/subject.model';
import { QuestionFilters } from '@/views/Subject.vue';
import getLevel from '@/utils/common/get-level';

export interface NormalizeForm {
  name: string;
  chapters: FilterItem[];
}

@Component({
  components: {
    FilterCommon,
    FilterBase,
    Divider,
  },
})
export default class PublicQuestionFilter extends Vue {
  @Prop({ default: [] })
  forms!: Form[];

  @Prop()
  questionFilters!: QuestionFilters;

  @Prop()
  updateFilters!: (param: QuestionFilters) => void;

  @Prop()
  closeFilter!: () => void;

  @Prop()
  isLoadingQuestions!: boolean;

  @Prop()
  isLoadingAddQuestions!: boolean;

  @Prop({ default: [] })
  availableLanguages!: string[];

  @Prop()
  subjectUuid!: string;

  @Prop()
  isSubjective!: boolean;

  @Prop()
  showFilter!: boolean;

  @Prop()
  initialLevel!: number;

  @Prop()
  subjectType!: SubjectType;

  get isParentLoading() {
    return this.isLoadingQuestions || this.isLoadingAddQuestions;
  }

  get questionType() {
    if (this.isSubjective) {
      return 'objective questions';
    } else {
      return 'subjective questions';
    }
  }

  localFilters: QuestionFilters | null = null;
  normalizeForms: NormalizeForm[] = [];
  selectedAllForms: string[] = [];

  created() {
    this.localFilters = {
      chapterIds: this.questionFilters.chapterIds,
      languages: this.questionFilters.languages,
      sortBy: this.questionFilters.sortBy,
      difficulties: this.questionFilters.difficulties,
      keyword: this.questionFilters.keyword,
    };

    if (this.initialLevel) {
      this.selectedAllForms = [getLevel(this.initialLevel)];
    }

    this.normalizeFormFilter();
  }

  mounted() {
    if (this.showFilter) {
      this.removeBodyScroll(true);
    } else {
      this.removeBodyScroll(false);
    }
  }

  beforeDestroy() {
    this.removeBodyScroll(false);
  }

  // NOTE: Remove scrolling on body when modal open
  removeBodyScroll(isRemove: boolean) {
    const bodyElement = document.getElementsByTagName('BODY')[0];

    if (isRemove) {
      bodyElement.className = 'body-open-filter';
    } else {
      bodyElement.className = '';
    }
  }

  filterChapterChanged(form: {
    name: string;
    items: FilterItem[];
    isAllSelected: boolean;
  }) {
    const newForm = {
      name: form.name,
      chapters: form.items,
    };

    if (form.isAllSelected) {
      this.selectedAllForms.push(form.name);
    } else {
      this.selectedAllForms = this.selectedAllForms.filter(
        e => e !== form.name,
      );
    }

    const existingForm = this.normalizeForms.find(
      normalizeForm => normalizeForm.name === form.name,
    );

    if (existingForm) {
      const index = this.normalizeForms.indexOf(existingForm);
      this.normalizeForms[index] = newForm;
    }
  }

  doneClicked() {
    if (this.isParentLoading) return;

    const selectedChapterIds: string[] = [];
    this.normalizeForms.forEach(normalizeForm => {
      const chapterIds = normalizeForm.chapters
        .filter(chapter => {
          return chapter.isChecked;
        })
        .map(chapter => {
          return chapter.id;
        });

      selectedChapterIds.push(...chapterIds);
    });

    if (this.localFilters) {
      this.localFilters.chapterIds = selectedChapterIds;

      this.updateQueryUrl();

      this.updateFilters(this.localFilters);
    }
  }

  updateQueryUrl() {
    const queryUrls = {};

    if (this.selectedAllForms.length === 1) {
      queryUrls['level'] = this.selectedAllForms[0]
        .replaceAll(' ', '_')
        .toLowerCase();
    } else {
      queryUrls['level'] = null;
      delete queryUrls['level'];
    }

    if (this.isSubjective) {
      queryUrls['is-subjective'] = true;
    } else {
      queryUrls['is-subjective'] = false;
      delete queryUrls['is-subjective'];
    }

    let isSameQuery = false;

    if (this.$route.query.level === queryUrls['level']) {
      isSameQuery = true;
    }

    if (!isSameQuery) {
      this.$router.push({
        path: this.$router.currentRoute.path,
        query: {
          ...queryUrls,
        },
      });
    }
  }

  doneWithCloseClicked() {
    this.doneClicked();
    this.closeFilter();
  }

  closeClicked() {
    this.closeFilter();
  }

  normalizeFormFilter() {
    this.normalizeForms = this.forms.map(form => {
      let isAllSelected = true;

      const formName = getLevel(form.index);

      const chapters: FilterItem[] = form.chapters.map(chapter => {
        const chapterName = `Chapter ${chapter.prefix}`;
        const id = `${chapter.id}`;
        const isChecked = this.initialLevel === chapter.form ? true : false;

        if (!isChecked) {
          isAllSelected = false;
        }

        return {
          id,
          value: chapterName,
          isChecked,
        };
      });

      return {
        name: formName,
        chapters,
        isAllSelected,
      };
    });
  }

  otherQuestionClick() {
    let link = `/subjects/${this.subjectUuid}/${this.subjectType}`;

    if (!this.isSubjective) {
      link += '?is-subjective=true';
    }

    this.$emit('updateAllLoadingState', true);

    this.$router
      .replace({
        path: link,
      })
      .then(() => {
        this.$router.go(0);
      });
  }

  smallOtherQuestionClick() {
    this.closeFilter();
    this.otherQuestionClick();
  }
}
